module.exports = __webpack_public_path__ + "static/img/1.323402c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/1.png
// module id = kEHQ
// module chunks = 0